// extracted by mini-css-extract-plugin
export default {"popupBody":"Feedback_popupBody__9Je+V","closeBtn":"Feedback_closeBtn__l18NG","callAlert":"Feedback_callAlert__m9une"};